import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { EstablecimientoInterface } from "../models/establecimiento.model";

@Injectable({
  providedIn: 'root'
})
export class EstablecimientosService extends ApiService<EstablecimientoInterface> {
  url = "establecimientos";
}
